import { render } from "./DashboardHomepage.vue?vue&type=template&id=6c26ed01"
import script from "./DashboardHomepage.vue?vue&type=script&lang=js"
export * from "./DashboardHomepage.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__